import apiService from '../utils/apiInterceptor';

const productService = {
  getSchedoxCatalog: async () => {
    return await apiService.get('/admin/schedox-catalog');
  },

  pricing: async () => {
    return await apiService.get('/pricing');
  },
  getAllProducts: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add each param to query string if it exists
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.category_id) queryParams.append('category_id', params.category_id);
      if (params.category_type_id) queryParams.append('category_type_id', params.category_type_id);
      if (params.order_id) queryParams.append('order_id', params.order_id);
      if( params.user_id) queryParams.append('user_id', params.user_id);
      if (params.status !== null && params.status !== undefined) 
        queryParams.append('status', params.status);
      if (params.sort_field) queryParams.append('sort_field', params.sort_field);
      if (params.sort_order) queryParams.append('sort_order', params.sort_order);
      
      const queryString = queryParams.toString();
      const url = `/admin/product${queryString ? `?${queryString}` : ''}`;
      
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllPacks: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add each param to query string if it exists
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.user_id) queryParams.append('user_id', params.user_id);
      if (params.search) queryParams.append('search', params.search);
      if (params.order_id) queryParams.append('order_id', params.order_id);
      if (params.category_id) queryParams.append('category_id', params.category_id);
      if (params.status !== null && params.status !== undefined) 
        queryParams.append('status', params.status);
      
      const queryString = queryParams.toString();
      const url = `/admin/pack${queryString ? `?${queryString}` : ''}`;
      
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },


  getProductById: async (id) => {
    try {
      const response = await apiService.get(`/admin/product/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getProductsByCategory: async (categoryId) => {
    try {
      const response = await apiService.get(`/admin/product?category_id=${categoryId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createProduct: async (productData) => {
    try {
      const response = await apiService.post('/admin/product', productData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateProduct: async (id, productData) => {
    try {
      const response = await apiService.post(`/admin/product/${id}`, productData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-HTTP-Method-Override': 'PUT'
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteProduct: async (id) => {
    try {
      const response = await apiService.delete(`/admin/product/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateProductStatus: async (id, status) => {
    try {
      const response = await apiService.post('/admin/change-product-status', {
        product_id: id,
        status: status
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportProducts: async () => {
    try {
      const response = await apiService.get('/admin/product/export', {
        responseType: 'blob'
      });
      
      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'products.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      return true;
    } catch (error) {
      throw error;
    }
  },

  updateInventory: async (productId, quantity) => {
    try {
      const response = await apiService.post('/admin/update-quantity', {
        product_id: productId,
        quantity: quantity
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // For pack management
  getPackItems: async (packId) => {
    try {
      const response = await apiService.get(`/admin/pack/${packId}/items`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  addPackItem: async (packId, itemData) => {
    try {
      const response = await apiService.post(`/admin/pack/${packId}/items`, itemData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  removePackItem: async (packId, itemId) => {
    try {
      const response = await apiService.delete(`/admin/pack/${packId}/items/${itemId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default productService;
